<template>
    <div class="DefaultLayout">
        <label v-if="label" class="DefaultLayout__label" :for="uniqueId">
            <slot name="labelPrefix" />
            {{ label }}
            <span v-if="required" class="DefaultLayout__required">
                <slot name="requiredIndicator">*</slot>
            </span>
            <slot name="labelPostfix" />
        </label>
        <div class="DefaultLayout__inputContainer">
            <slot name="inputContainerPrefix" />
            <div class="DefaultLayout__input" :class="inputContainerClass">
                <slot name="inputInnerPrefix" />
                <!--Main Input-->
                <slot v-bind="{ id: uniqueId }" />
                <slot name="inputInnerPostfix" />
            </div>
            <slot name="inputContainerPostfix" />
        </div>
        <div v-if="error" class="DefaultLayout__error">
            <slot name="errorPrefix">
                <EidIcon :icon-src="faExclamationTriangle" />
            </slot>
            <div class="DefaultLayout__errorMessage">
                {{ error }}
            </div>
            <slot name="errorPostfix" />
        </div>
    </div>
</template>

<style lang="scss">
@import "../style-variables.scss";

.DefaultLayout {
    display: flex;
    flex-flow: column;
    gap: 7px;

    &__label {
        font-size: $label-font-size;
        line-height: $line-height;
        color: $label-color;
    }

    &__input {
        flex: 1;
        min-width: 0;
    }

    &__inputContainer {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    &__error {
        color: var(--eidDangerRed);
        display: flex;
        gap: 7px;
    }

    &__required {
        color: var(--eidDangerRed);
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { v4 as uuidv4 } from 'uuid';

    import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    export default defineComponent({
        name: 'DefaultLayout',
        components: {
            EidIcon,
        },
        props: {
            label: {
                type: String,
                required: true,
            },
            inputContainerClass: {
                type: String,
                default: '',
            },
            error: {
                type: String,
                default: '',
            },
            required: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                uniqueId: '',
                faExclamationTriangle,
            };
        },
        created() {
            this.uniqueId = uuidv4();
        },
    });
</script>
